import { JsonPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { DynamicModule } from 'ng-dynamic-component';
import { CarouselComponent } from 'src/app/components/carousel/carousel.component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-grid',
  imports: [
    NgFor,
    NgIf,
    DynamicModule,
    NgClass,
    JsonPipe,
    StoryblokDirective,
    CarouselComponent,
  ],
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
})
export class GridComponent implements OnChanges {
  components: any;
  @Input() column_count: number = 4;
  @Input() column_count_mobile: number = 1;
  @Input() justify:
    | 'justify-content-center'
    | 'justify-content-start'
    | 'justify-content-end' = 'justify-content-start';
  options = {
    0: { slides: 1.2, nav: false },
  };
  constructor() {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  ngOnChanges(): void {
    this.columns = this.columns.filter((x) => !x.hidden);
    for (let entry of this.columns) {
      if (entry.component === 's-image') {
        entry.mode = 'fill';
      }
    }
  }

  @Input() _uid!: string;
  @Input() component!: string;

  @Input() columns!: any[];
  @Input() _editable: any;
}
